<template>
  <div>
    <!--    充电记录-->
    <el-table
        v-if="active2 === 0"
        :data="tableData"
        style="width: 100%"
        :header-cell-style='{background: "#6cc9eb", color: "#fff"}'
    >
      <el-table-column
          prop="date"
          label="订单号"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="name"
          label="用户名称"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="联系电话">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="充值金额">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="退款金额">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          width="100"
          label="充电桩枪号">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="交易状态">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          width="120"
          label="充电电量(kWh)">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          width="100"
          label="充电时长(h)">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="创建时间">
      </el-table-column>
    </el-table>
    <!--    历史事件-->
    <el-table
        v-else
        :data="tableData"
        style="width: 100%"
        :header-cell-style='{background: "#6cc9eb", color: "#fff"}'
    >
      <el-table-column
          prop="date"
          label="站点名称"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="name"
          label="充电桩枪号"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="类型">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="状态">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="故障内容">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="发生时间">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "table",
  props: ["active2"],
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    }
  }
}
</script>

<style scoped lang="less">
</style>